import axios from 'axios';
import store from '@/store';
import { registerIdentity, getSelectedRegister } from './pos/registerSelection.mjs';

function normalizeBaseUrl(value) {
  const raw = String(value || '').trim();

  // En produccion la API vive en el mismo dominio bajo /api.
  // Si VUE_APP_API_URL queda vacio, mal escrito, undefined o null, usamos rutas relativas.
  if (!raw || raw === 'undefined' || raw === 'null' || raw === '/') {
    return '';
  }

  return raw.replace(/\/$/, '');
}

const api = axios.create({
  baseURL: normalizeBaseUrl(process.env.VUE_APP_API_URL),
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = store?.state?.authToken;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const path=String(config.url||'');
  if (path.startsWith('/api/pos/')) {
    const selection=getSelectedRegister(registerIdentity(store.state));
    if (selection) config.headers['X-POS-Register-ID']=String(selection);
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      store.commit('clearSession');
    }
    return Promise.reject(error);
  }
);

export default api;
